import React, { useContext, useState, useEffect } from "react";
import {
  Grid,
  Stack,
  Typography,
  Button,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  TextField,
  DialogActions,
} from "@mui/material";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
//Icons
import { BiMinusCircle } from "react-icons/bi";
import DoDisturbOnOutlinedIcon from "@mui/icons-material/DoDisturbOnOutlined";
import CircularProgress from "@mui/material/CircularProgress";
//Srcs
import "../../src/Style/dialogStyle.scss";
import { AuthContext } from "../../src/Context/AuthContext";
import { translateLauguage } from "../../src/Function/Translate";
import logout from "../Assets/log-out.png";

export const LogoutDialog = ({ open, handleClose }) => {
  // ===================== Change Language ==========================
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [iconReload, setIconReload] = useState(false);

  //======================== function logout ======================
  const handleLogout = async () => {
    setIconReload(true);
    setTimeout(() => {
      handleClose();
      setIconReload(false);
      //===================== remove token ===========================
      window.localStorage.clear();
      window.location.reload("/login");
    }, 800);
  };

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="xs">
      <DialogContent>
        <Stack
          direction="column"
          justifyContent="space-between"
          className="logout-container"
        >
          <Stack direction={`row`} justifyContent="center">
            <img src={logout} alt="logout" className="img-log" />
          </Stack>
          <Stack direction={`row`} justifyContent="center">
            <Stack
              direction={`column`}
              justifyContent="center"
              alignItems={`center`}
              spacing={0.5}
            >
              <Typography
                className={
                  language === "en" ? "question-txt" : "question-txt-kh"
                }
              >
                {t("log_out_qa")}
              </Typography>
              <Typography
                className={language === "en" ? "desc-txt" : "desc-txt-kh"}
              >
                {t("log_out_desc")}
              </Typography>
            </Stack>
          </Stack>
          <Stack
            direction="row"
            justifyContent="center"
            width="400px"
            marginTop="10px"
            spacing={1}
          >
            <Stack direction="row" justifyContent="center" width="200px">
              <Button
                onClick={handleClose}
                autoFocus
                fullWidth
                sx={{
                  backgroundColor: "#f75257",
                  color: "white",
                  ":hover": {
                    backgroundColor: "#f75257",
                  },
                }}
              >
                <Typography className="log-out-txt">{t("cancel")}</Typography>
              </Button>
            </Stack>
            <Stack direction="row" justifyContent="center" width="200px">
              <Button
                onClick={handleLogout}
                autoFocus
                fullWidth
                sx={{
                  backgroundColor: "#0f81c2",
                  color: "white",
                  ":hover": {
                    backgroundColor: "#0f81c2",
                  },
                  // fontFamily: "Kantumruy Pro",
                }}
                endIcon={
                  iconReload ? (
                    <CircularProgress sx={{ color: "#fff" }} size="20px" />
                  ) : null
                }
              >
                <Typography className="log-out-txt">{t("log_out")}</Typography>
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
